import { PowerPerformanceForms } from '../types/mutual-fund-detail.types'

export const formMetaData: Record<
  string,
  {
    label: string
    color: string
    textColor: string
    iconSvg: string
  }
> = {
  [PowerPerformanceForms.IN_FORM]: {
    label: 'In-form',
    color: '#CBF7D7',
    textColor: '#00661D',
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M9.98811 4.91837L6.00001 1.5L2.01192 4.91837C1.69743 5.18793 1.661 5.66141 1.93057 5.9759C2.20014 6.2904 2.67361 6.32682 2.98811 6.05725L6.00001 3.47562L9.01192 6.05725C9.32641 6.32682 9.79989 6.2904 10.0695 5.9759C10.339 5.66141 10.3026 5.18793 9.98811 4.91837ZM9.98811 8.91837L6.00001 5.5L2.01192 8.91837C1.69743 9.18793 1.661 9.66141 1.93057 9.9759C2.20014 10.2904 2.67361 10.3268 2.98811 10.0573L6.00001 7.47562L9.01192 10.0573C9.32641 10.3268 9.79989 10.2904 10.0695 9.9759C10.339 9.66141 10.3026 9.18793 9.98811 8.91837Z" fill="#00661D"/>
</svg>`
  },
  [PowerPerformanceForms.ON_TRACK]: {
    label: 'On-track',
    color: '#E4FCEB',
    textColor: '#00661D',
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#00661D" d="M5.25 10V3.81L2.53 6.53a.75.75 0 1 1-1.06-1.06l4-4 .056-.052a.75.75 0 0 1 1.004.052l4 4a.75.75 0 1 1-1.06 1.06L6.75 3.81V10a.75.75 0 0 1-1.5 0Z"/></svg>`
  },
  [PowerPerformanceForms.OFF_TRACK]: {
    label: 'Off-track',
    color: '#FFF4E6',
    textColor: '#995400',
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#995400" d="M6.75 2v6.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4-.056.052a.75.75 0 0 1-1.004-.052l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 1 1 1.5 0Z"/></svg>`
  },
  [PowerPerformanceForms.OUT_OF_FORM]: {
    label: 'Out-of-form',
    color: '#FFE9E6',
    textColor: '#992617',
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M2.01189 7.08163L5.99999 10.5L9.98808 7.08163C10.3026 6.81207 10.339 6.33859 10.0694 6.0241C9.79986 5.7096 9.32639 5.67318 9.01189 5.94275L5.99999 8.52438L2.98808 5.94275C2.67359 5.67318 2.20011 5.7096 1.93054 6.0241C1.66098 6.33859 1.6974 6.81207 2.01189 7.08163ZM2.01189 3.08163L5.99999 6.5L9.98808 3.08163C10.3026 2.81207 10.339 2.33859 10.0694 2.0241C9.79986 1.7096 9.32639 1.67318 9.01189 1.94275L5.99999 4.52438L2.98808 1.94275C2.67359 1.67318 2.20011 1.7096 1.93054 2.0241C1.66098 2.33859 1.6974 2.81207 2.01189 3.08163Z" fill="#992617"/>
</svg>`
  },
  [PowerPerformanceForms.NOT_RATED]: {
    label: 'Unrated',
    color: '#F6F9F9',
    textColor: '#6A6E6E',
    iconSvg: ``
  },
  [PowerPerformanceForms.PERFORMANCE_LOCKED]: {
    label: 'Locked',
    color: '#F5F5F5',
    textColor: '#6A6E6E',
    iconSvg: ``
  }
}

export const getPowerFormMetaData = (form: `${PowerPerformanceForms}`) => {
  return formMetaData[form] ?? { label: '' }
}

export const getPowerFormLabel = (form: `${PowerPerformanceForms}`) => getPowerFormMetaData(form)?.label

export const getPowerFormFromLabel = (label: string) =>
  Object?.keys(formMetaData)?.filter((key) => formMetaData?.[key]?.label === label)?.[0]

export const getPowerFormIconSVG = (form: `${PowerPerformanceForms}`) => getPowerFormMetaData(form)?.iconSvg
